import React from 'react'
import { SelectInput } from 'react-admin'
import { RAInputProps } from 'types/common'
import CustomReferenceInput from './CustomReferenceInput'

const SupplierSelectInput: React.FC<RAInputProps> = (props) => {
  return (
    <CustomReferenceInput entity="suppliers">
      <SelectInput {...props} label="Supplier" />
    </CustomReferenceInput>
  )
}

export default SupplierSelectInput
